export default __webpack_public_path__ + "static/media/cycle.44295291.png";